import { CommonModule } from '@angular/common';
import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import {
    FormBuilder,
    FormGroup,
    ReactiveFormsModule,
    Validators,
} from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { scrollToFirstInvalidControl } from 'app/shared/utils';
import { BukkuService } from '../../bukku.service';
import { ToastrService } from 'ngx-toastr';

@Component({
    selector: 'app-bukku-form',
    standalone: true,
    imports: [
        CommonModule,
        TranslateModule,
        MatIconModule,
        ReactiveFormsModule,
    ],
    templateUrl: './bukku-form.component.html',
    styleUrl: './bukku-form.component.scss',
})
export class BukkuFormComponent {
    @Input() selectedLanguage: string = 'en';
    @Input() data: any;
    @ViewChild('formContainer') formContainer!: ElementRef;

    form: FormGroup;
    isLoading: boolean = false;

    selectedValue: { en: string; bm: string } | null = null;

    constructor(
        private fb: FormBuilder,
        private _bukkuService: BukkuService,
        private toaster: ToastrService
    ) {
        this.form = this.fb.group({
            name: [
                '',
                [
                    Validators.required,
                    Validators.minLength(1),
                    Validators.maxLength(100),
                    Validators.pattern(/^[A-Za-z0-9\s]{1,100}$/),
                ],
            ],
            email: [
                '',
                [
                    Validators.required,
                    Validators.maxLength(254),
                    Validators.pattern(
                        /^(?!\.)(?!.*\.\.)(?!.*\.$)(?!.*\.@)([A-Za-z0-9][A-Za-z0-9._-]{0,63})@([A-Za-z0-9](?:[A-Za-z0-9-]{0,61}[A-Za-z0-9])?)(?:\.[A-Za-z0-9](?:[A-Za-z0-9-]{0,61}[A-Za-z0-9])?)+$/
                    ),
                ],
            ],
            phoneNumber: [
                '',
                [
                    Validators.required,
                    Validators.pattern(/^(?:\+?60)?[0-9]{9,11}$/),
                ],
            ],
            companyName: [
                '',
                [
                    Validators.required,
                    Validators.maxLength(255),
                    Validators.pattern(/^[A-Za-z0-9&,.()\-\s]{1,255}$/),
                ],
            ],
            message: ['', [Validators.maxLength(1000)]],
            termsConditions: [false, Validators.requiredTrue],
        });
    }

    submitForm() {
        if (this.form.invalid) {
            scrollToFirstInvalidControl(this.formContainer.nativeElement);
            this.form.markAllAsTouched();
            return;
        }
        this.isLoading = true;
        const values = this.form.value;

        const finalObj = {
            name: values.name,
            email: values.email,
            phoneNumber: '+60' + values.phoneNumber,
            companyName: values.companyName,
            message: values.message,
            privacyPolicyCheck: values.termsConditions,
            orgCode: this.data?.orgCode || 'BUKK',
        };

        this._bukkuService.submitBukkuForm(finalObj).subscribe({
            next: (data) => {
                if (data?.message) {
                    const msg =
                        this.selectedLanguage === 'en'
                            ? 'Form submitted successfully'
                            : 'Borang berjaya dihantar';
                    this.toaster.success(msg);
                    this.form.reset();
                }
                this.isLoading = false;
            },
            error: (err) => {
                console.log('error', err);
                const msg =
                    this.selectedLanguage === 'en'
                        ? 'Something went wrong!'
                        : 'Terdapat masalah, sila cuba lagi!';
                this.toaster.error(msg);
                this.isLoading = false;
            },
        });
    }

    allowLetters(event: KeyboardEvent) {
        const char = String.fromCharCode(event.keyCode);
        const pattern = /^[a-zA-Z\s]*$/;
        if (!pattern.test(char)) {
            event.preventDefault();
        }
    }

    allowNumbers(event: KeyboardEvent) {
        const char = String.fromCharCode(event.keyCode);
        const pattern = /^[0-9]*$/;
        if (!pattern.test(char)) {
            event.preventDefault();
        }
    }
}
